<template>
<!-- 会员管理－会员信息详情 -->
    <div>
    <content-view v-show="$utils.renderWhen(this,'vipDetail')">
        <a-card :bordered="false" title="会员账号详情">
            <a-row class="mt8">
                <a-col :span="6">手机账号：{{valuesForm.phone}}</a-col>
                <a-col :span="12">账号人姓名：{{valuesForm.name}}
                    <a-tag v-for="item in valuesForm.labelList" :key="item.id" :color="item.color">
                        {{item.name}}
                    </a-tag>
                </a-col>
            </a-row>
        </a-card>

        <div class="mt24"></div>
        <a-card :bordered="false" title="会员储值详情">
            <div slot="extra">
                <a class="text-primary" @click="clearValue">储值余额清空</a>
                <a-divider type="vertical"/>
                <router-link class="text-primary" :to="{name: 'storedVlaueUseRecored',query: {phone: valuesForm.phone}}">储值余额消费记录</router-link>
            </div>
            <a-row class="mt8">
                <a-col :span="6">储值余额：{{valuesForm.amount}} 元</a-col>
                <div slot="extra">
                    <a class="text-primary" @click="clearValue">储值余额清空</a>
                    <a-divider type="vertical"/>
                    <router-link class="text-primary" :to="{name: 'storedVlaueUseRecored',query: {phone: valuesForm.phone}}">储值余额消费记录</router-link>
                </div>
            </a-row>
        </a-card>
        <div class="mt24"></div>
        <a-card :bordered="false" v-show="valuesForm.babyName" title="会员信息完善详情" :tabList="tabList" :activeTabKey="key" @tabChange="key => onTabChange(key, 'noTitleKey')">
            <a-row class="mt8">
                <a-col :span="7"><img :src="valuesForm.imgUrl" width="230" alt="暂无照片"></a-col>
                <a-col :span="6" class="mb8">该会员与宝宝的关系：{{valuesForm.relationBaby}}</a-col>
                <a-col :span="6" class="mb8">宝宝姓名：{{valuesForm.babyName}}</a-col>
                <a-col :span="6" class="mb8">宝宝生日：{{valuesForm.birthday}}</a-col>
                <a-col :span="6" class="mb8" v-for="item in userBabyRelations" :key="item.id">{{item.relation}}：{{item.name}}</a-col>
            </a-row>
        </a-card>
        <a-card :bordered="false" v-show="!valuesForm.babyName" title="会员信息完善详情" >
            <a-empty class=" mb24" description="暂无宝宝"/>
        </a-card>


        <div slot="footer">
            <div class="text-right mt16 mr16 mb16">
                <a-button @click="$router.go(-1)">返回</a-button>
            </div>
        </div>
    </content-view>
    <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: "vipDetail",
        components: {},
        props: {},
        data() {
            return {
                userBabyRelations: [],
                valuesForm: {},
                tabList: [],
                key: undefined,
                relationBaby: ['--','爸爸','妈妈','爷爷','奶奶','外公','外婆','其他亲人','叔叔','阿姨']
            };
        },
        computed: {},
        methods: {
            getDetail() {
                // 目前是一个账号对应一个宝宝，展示了宝宝的爸爸妈妈姓名
                // 未来要改为一个账号对应多个宝宝，展示的宝宝信息也是根据APP填写的来获取
                // 已改为多个宝宝
                this.$api.member.viewMemberInfo({
                    params: {
                        userId: this.$route.params.id
                    }
                }).then(res => {
                    this.tabList = []
                    this.valuesForm = {
                        phone: res.phone,
                        name: res.name,
                        amount: res.balanceValue,
                        labelList: res.labelList
                    }
                    let flag = true
                    res.userBabyList.map(item => {
                        this.tabList.push({
                            ...item,
                            key: item.id.toString(),
                            tab: item.babyName
                        })
                        // 如果已设置了默认宝宝
                        if(item.defaultBaby === 1) {
                            flag = false
                            this.key = item.id.toString()
                            this.valuesForm = {
                                ...this.valuesForm,
                                babyName: item.babyName || '--',
                                birthday: item.birthday || '--',
                                relationBaby: this.relationBaby[item.relationBaby] || '--',
                                imgUrl: item.imgUrl,
                            }
                            this.userBabyRelations = item.userBabyRelations;
                        }
                    })
                    // 未设置默认宝宝－默认显示第一个宝宝
                    if(flag && res.userBabyList[0]) {
                        this.key = res.userBabyList[0].id.toString();
                        this.valuesForm = {
                            ...this.valuesForm,
                            babyName: res.userBabyList[0].babyName || '--',
                            birthday: res.userBabyList[0].birthday || '--',
                            relationBaby: this.relationBaby[res.userBabyList[0].relationBaby] || '--',
                            imgUrl: res.userBabyList[0].imgUrl,
                        }
                        this.userBabyRelations = res.userBabyList[0].userBabyRelations;
                    }
                })
            },
            clearValue() {
                let _this = this
                _this.$confirm({
                    title: '提示',
                    okText: '取消',
                    cancelText: '确定清空',
                    centered: true,
                    // okType: 'default',
                    content: '您确定将手机号为'+_this.valuesForm.phone+'的用户储值余额清空吗？一旦清空后，该用户储值余额为零。清空前，请确定财务已线下退款给用户。请谨慎操作！',
                    onOk() {},
                    onCancel() {
                        _this.$api.member.manualRefund({
                            params: {
                                userId: _this.$route.params.id
                            }}
                        ).then(res => {
                            _this.$message.success('操作成功')
                            _this.getDetail()
                        })
                    },
                });
            },
            onTabChange (key, type) {
                this.key = key
                this.tabList.map(item => {
                    if(item.id == key) {
                        this.valuesForm = {
                            ...this.valuesForm,
                            babyName: item.babyName || '--',
                            birthday: item.birthday || '--',
                            relationBaby: this.relationBaby[item.relationBaby] || '--',
                            imgUrl: item.imgUrl,
                        }

                        this.userBabyRelations = item.userBabyRelations;
                    }
                })
            },
        },
        mounted() {
            this.getDetail();
        },
    };
</script>
<style lang="scss">
    .vip-detail {
        .block-title {
            margin: 16px 0;
            font-size: 16px;
            line-height: 32px;
            font-weight: 900;
            color: rgba(0, 0, 0, 0.85);
        }
        .line {
            border-top: 1px solid #e8e8e8;
            margin-top: 16px;
        }
    } 
</style>